export var LOCALES;
(function (LOCALES) {
    LOCALES["EN"] = "en";
    LOCALES["RU"] = "ru";
})(LOCALES || (LOCALES = {}));
export const defaultLang = LOCALES.RU;
export const allowedLangs = [LOCALES.RU, LOCALES.EN];
